.svs-thumbnail {
  object-fit: contain;
  min-height: 140px;
}

.large {
  width: 150px;
  height: 150px;
}

.medium {
  width: 100px;
  height: 100px;
}

.small {
  width: 52px;
  height: 52px;
  min-height: unset;
}

.dynamic {
  height: 100%;
  min-height: unset;
  width: 100%;
}
